import moment from "moment";
import { PlatformAnalyticsReport, AudienceAnalyticsReport, AudienceStatsModelv1, NivoLineSeries } from "modules/insights";
import { AccountType } from "modules/users";
import { Audience } from "modules/audiences";

export const ORIGINAL_DATE_FORMAT = "MMM D, YYYY, h:mmA";

export const FILTER_BY_AUDIENCES = "Audiences";
export const FILTER_BY_TOPICS = "Topics";
export const FILTER_BY_CUSTOM_AUDIENCES = "Custom Audiences";
export const FILTER_BY_CUSTOM_TOPICS = "Custom Topics";

//Minimum date for audience analytics
export const AUDIENCE_ANALYTICS_MIN_DATE = moment("2025-01-01");
export const NIVO_CHART_COLORS = ["#e6911a","#366531","#3b78ab","#453a6e","#36404a","#599fa0","#aa214e", "#e9b848", "#b72026", "#1b386b"];
export const EVERYONE_INTERNAL_AUDIENCE_NAME = "Everyone Internal";

export enum LoadTypes { "all", "excel", "image" };

export const DEFAULT_EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const ALL_AUDIENCES_SELECTION: Audience = {
    id: DEFAULT_EMPTY_GUID,
    displayName: 'All users (default)',
    description: '',
    enabled: true,
    type: ''
};

export const getReportFileName = (reportType: string) => {
    switch (reportType) {
        case PlatformAnalyticsReport.channelUsage:
            return 'Channel Usage';
        case PlatformAnalyticsReport.commentsAndReactions:
            return 'Post Reactions and Comments';
        case PlatformAnalyticsReport.engagedUsers:
            return 'Engaged Users';
        case PlatformAnalyticsReport.mostViewedEvent:
            return 'Events with Most Views';
        case PlatformAnalyticsReport.mostViewedPost:
            return 'Posts with Most Views';
        case PlatformAnalyticsReport.postViewsByHour:
            return 'Post Views by Time of Day';
        case PlatformAnalyticsReport.surveyWithMostResponse:
            return 'Surveys with Most Responses';
        case AudienceAnalyticsReport.audienceViewTrends:
            return 'Audience View Trends';
        case AudienceAnalyticsReport.uniqueViewsByChannel:
            return 'Unique Views by Channel';
        case AudienceAnalyticsReport.uniqueViewsByLanguage:
            return 'Unique Views by Language';
        default: 
            return "";
    }
}

/*
* Maps AudienceStatsModelv1 to NivoLineSeries format for charting.
* Uses UTC format for x-axis labels since the time is coming back in UTC.
* Converts yearMonth to a formatted string and maps uniqueTotalViewCount to y value.
*/
export const mapAudienceStatsToNivoLineSeries = (data: AudienceStatsModelv1[]): NivoLineSeries[] => {
    return data.map(series => ({
        id: series.id,
        data: series.audienceStatsData
            .sort((a, b) => moment(a.yearMonth).valueOf() - moment(b.yearMonth).valueOf())
            .map(point => ({
                x: moment.utc(point.yearMonth).format('MMMM YYYY'),
                y: point.uniqueTotalViewCount,
                viewRate: Number((point.viewRate * 100).toFixed(2))
            })),
    }));
}

export const getAccountProviderLabel = (accountType: string): string => {
    switch(accountType) {
        case AccountType.Work:
            return "Work";
        case AccountType.Google:
            return "Google";
        case AccountType.LinkedIn:
            return "LinkedIn";
        case AccountType.Facebook:
            return "Facebook";
        case AccountType.Apple:
            return "Apple";
        case AccountType.Microsoft:
            return "Microsoft Personal";
        case AccountType.Sparrow:
            return "Sparrow";
        default:
            return accountType;
    }
}

export const REPORT_TITLES = {
    audienceViewTrends: {
        title: "Audience View Trends",
        infoText: "The cumulative count of unique views from top-performing audiences over time. A single user who belongs to multiple audiences contributes multiple views, one for each audience.",
    },
    uniqueViewsByChannel: {
        title: "Unique Views by Channel",
    },
    uniqueViewsByLanguage: {
        title: "Unique Views by Language",
    },
};